import React from 'react';
import { WebsiteDesignProps } from './types';
// Icons not currently used but available: AlignLeft, Type, Quote
import { Button } from "@/components/ui/button";

const TypographyFocus: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Type Foundry";

    return (
        <div className="bg-[#f2f2f2] text-[#111] min-h-screen font-serif">
            <div className="p-4 border-b border-black flex justify-between items-baseline sticky top-0 bg-[#f2f2f2] z-50">
                <h1 className="text-4xl font-bold tracking-tighter leading-none">{schoolName}</h1>
                <div className="font-sans text-xs uppercase font-bold tracking-widest hidden md:block">
                    Typography • Design • History
                </div>
            </div>

            <main className="container mx-auto px-4 py-20 max-w-5xl">
                <div className="mb-24">
                    <h2 className="text-6xl md:text-8xl font-light mb-8 leading-[0.9]">
                        Reviewing the <br/> <i className="font-serif">structure</i> <br/> of language.
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 font-sans text-lg">
                        <p>
                            We believe that legibility is the foundation of communication. Our curriculum explores the intricate history of letterforms and their application in modern media.
                        </p>
                        <p className="text-gray-500">
                            From Gutenberg to web fonts, understanding the mechanics of reading is essential for any serious designer.
                        </p>
                    </div>
                </div>

                <div className="border-t border-black pt-12 grid grid-cols-1 md:grid-cols-3 gap-12">
                     <div>
                         <div className="text-6xl font-black font-sans mb-4 opacity-10">Aa</div>
                         <h3 className="text-2xl font-bold mb-2">Grotesque</h3>
                         <p className="text-sm font-sans text-gray-600">Objective, clean, and modern. The voice of industry.</p>
                     </div>
                     <div>
                         <div className="text-6xl font-serif italic mb-4 opacity-10">Gg</div>
                         <h3 className="text-2xl font-bold mb-2">Humanist</h3>
                         <p className="text-sm font-sans text-gray-600">Warm, organic, and rooted in calligraphy. The voice of people.</p>
                     </div>
                     <div>
                         <div className="text-6xl font-mono mb-4 opacity-10">{}</div>
                         <h3 className="text-2xl font-bold mb-2">Monospace</h3>
                         <p className="text-sm font-sans text-gray-600">Technical, precise, and uniform. The voice of code.</p>
                     </div>
                </div>
                
                <div className="mt-20 text-center">
                    <Button variant="outline" className="border-black text-black hover:bg-black hover:text-white rounded-none px-12 py-6 uppercase font-sans font-bold text-xs tracking-widest">
                        Browse Collection
                    </Button>
                </div>
            </main>
        </div>
    );
};

export default TypographyFocus;
